import Vue from 'vue'
import VueRouter from 'vue-router'

import DonationWithCardScan from '../components/DonationWithCardScan.vue'
import ErrorReport from '../components/ErrorReport.vue'
import LandingPage from '../components/LandingPage.vue'
import NormalDonation from '../components/NormalDonation.vue'
import Receipt from '../components/Receipt.vue'
import Unexpected from '../components/Unexpected.vue'

Vue.use(VueRouter);

const routes = [
  // TODO: Uncomment this code to made debugging easier under WebPack
  // Leave it commented in release builds
  // {
  //   path: '/NormalDonationTest',
  //   name: 'TestNormalDonation',
  //   component: NormalDonation,
  // },
  {
    path: '/Cardscan',
    name: 'CardScan',
    component: DonationWithCardScan,
  },
  {
    path: '/Receipt',
    name: 'Receipt',
    component: Receipt,
  },
  {
    path: '/Donation',
    name: 'NormalDonation',
    component: NormalDonation,
  },
  {
    path: '/Errors',
    name: 'ErrorReport',
    component: ErrorReport,
  },
  {
    path: '/:accountType/:accountNumber/:amount/:zipCode',
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '/:accountType/:donorName/:amount',
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '*',
    name: 'Unexpected',
    component: Unexpected,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
